import {defineStore} from 'pinia'

interface RouteQuantityMap {
  [route: string]: number
}

export const useQuantityStore = defineStore('QuantityModule', () => {
  const routeQuantityMap = ref<RouteQuantityMap>({})

  const saveQuantity = (quantity: number | null | undefined) => {
    const route = useRoute()
    if (route?.path) {
      if (quantity === null || quantity === undefined) {
        const {[route.path]: _, ...rest} = routeQuantityMap.value
        routeQuantityMap.value = rest
      } else {
        routeQuantityMap.value = {...routeQuantityMap.value, [route.path]: quantity}
      }
    }
  }

  const saveQuantityForProduct = (sku: string, quantity: number) => {
    if (sku && quantity !== null && quantity !== undefined) {
      routeQuantityMap.value = {...routeQuantityMap.value, [sku]: quantity}
    }
  }

  const saveToCategoryPathIfNeeded = (path: string, quantity: number) => {
    const categoryMatch = path.match(/^(.+)\/[^/]+\/[^/]+$/)
    if (categoryMatch) {
      const categoryPath = categoryMatch[1]
      if (routeQuantityMap.value[categoryPath] === null || routeQuantityMap.value[categoryPath] === undefined) {
        routeQuantityMap.value = {...routeQuantityMap.value, [categoryPath]: quantity}
      }
    }
  }

  const getQuantity = (): number | null => {
    const route = useRoute()
    if (!route?.path) {
      return null
    }

    if (routeQuantityMap.value[route.path] !== null && routeQuantityMap.value[route.path] !== undefined) {
      return routeQuantityMap.value[route.path]
    }

    const path = route.path
    const segments = path.split('/').filter(Boolean)
    if (segments.length > 0) {
      const sku = segments[segments.length - 1]
      const quantity = routeQuantityMap.value[sku] ?? null

      if (quantity !== null) {
        saveToCategoryPathIfNeeded(path, quantity)
      }

      return quantity
    }
    return null
  }

  const clearQuantities = () => {
    routeQuantityMap.value = {}
  }

  return {
    // State
    routeQuantityMap,
    // Actions
    saveQuantity,
    saveQuantityForProduct,
    getQuantity,
    clearQuantities
  }
}, {
  persist: {
    storage: persistedState.localStorage,
    paths: ['routeQuantityMap']
  }
})
